import React, { useEffect, useState } from "react";
import SendTxTemplate from "./SendTxTemplate";
import { InputSendWallet } from "./InputSendWallet";
import { SendTransactionState, SendTransactionStateRecipient } from "../SendTransaction";
import { Pleb } from "../../../../models/Pleb";
import { useWalletSend } from "../../../../hooks/useWalletSend";

interface SendTxStep1Props {
    defaultRecipient?: SendTransactionStateRecipient;
    recipientAutoPost?: SendTransactionStateRecipient | null;
    onScanRecipient: (data: SendTransactionState) => void;
}

const SendTxStep1: React.FC<SendTxStep1Props> = ({ defaultRecipient, recipientAutoPost, onScanRecipient }) => {
    const [plebSelected, setPlebSelected] = useState<Pleb | null>(defaultRecipient?.pleb ?? null);
    const [lnurl, setLnurl] = useState(defaultRecipient?.lnurl ?? '');
    const {loading, error, scanRecipient} = useWalletSend();

    useEffect(() => {
        if(recipientAutoPost) {
            scanRecipientAndCallOnScanRecipient(recipientAutoPost);
        }
    }, [recipientAutoPost]);

    const scanRecipientAndCallOnScanRecipient = async (recipient: SendTransactionStateRecipient) => {
        const data = await scanRecipient(recipient);
        if(data) {
            onScanRecipient(data);
        }
    }
    
    return (
        <SendTxTemplate
            onButtonClick={() => scanRecipientAndCallOnScanRecipient({
                pleb: plebSelected,
                lnurl: lnurl
            })}
            buttonDisabled={lnurl === '' && plebSelected === null}
            buttonLoading={loading}
            error={error}
            className="min-h-[450px] justify-start"
        >
            <InputSendWallet
                onChangeLnurl={(lnurl) => {
                    setPlebSelected(null);
                    setLnurl(lnurl);
                }}
                onSelectLnurl={(lnurl) => {
                    scanRecipientAndCallOnScanRecipient({
                        pleb: null,
                        lnurl: lnurl,
                        bulkPayment: null
                    });
                }}
                onChangePleb={(pleb) => {
                    setLnurl('');
                    setPlebSelected(pleb);
                }}
                onSelectPleb={(pleb) => {
                    scanRecipientAndCallOnScanRecipient({
                        pleb: pleb,
                        lnurl: '',
                        bulkPayment: null
                    });
                }}
                onSelectBulkPayment={(bulkPayment) => {
                    scanRecipientAndCallOnScanRecipient({
                        pleb: null,
                        lnurl: '',
                        bulkPayment: bulkPayment
                    });
                }}
                defaultRecipient={defaultRecipient}
            />
        </SendTxTemplate>
    );
}

export default SendTxStep1;